import React, { Component } from 'react';

import Header from '../../header/header.js';
import Footer from '../../footer/footer.js';
import ContactForm from '../../support/contactform.js';

import IframeResizer from 'iframe-resizer-react';
import  {Helmet} from "react-helmet";


export default class HPDesign extends Component {

    constructor(props)
    {
        super(props);
        this.state = { framesrc: "https://designer.hpwallart.com/j2blueprint?external_link=true&sku=PSTR" };

    }


    render() {
        return(
            <div>
                 <Helmet>
				<title>J2 Blueprint Supply Co. |  Document Designer</title>	
			
				<meta name="description" content="Design print ready documents right in your browswer" />
                </Helmet>
            <Header page_services={true}/>
            
              <div role="main" className="main">

              

              <section className="section section-text-light section-background section-center section-overlay-opacity section-overlay-opacity-scale-8" style={{backgroundImage: "url(/j2img/hpdesign/page/donutsNew.jpg"}}>
					<div className="container">
						<div className="row">
							<div className="col">
                        
								<h4 className="mb-0">Create and Print</h4>
								<p className="mb-0">Professional looking large format prints with a suite of easy design tools</p>
							</div>
						</div>
					</div>
				</section>
                <div className="row">
                    <div className="col-md-3"></div>
                    <div className="col-md-6">

                    <div className="row">
						<div className="col">
							<div className="heading heading-border heading-middle-border heading-middle-border-center heading-border-xl">
								<h2 className="font-weight-normal">Select the product you'd like to <strong className="font-weight-extra-bold">Design</strong></h2>
							</div>
						</div>
					</div>
                    <div className="row justify-content-center">

                        <div className="col-6 col-sm-4 col-lg-2">
                            <div className="featured-boxes featured-boxes-modern-style-2 featured-boxes-modern-style-2-hover-only featured-boxes-modern-style-primary m-0 mb-4 pb-3">
                                <div className="featured-box featured-box-no-borders featured-box-box-shadow" style={{height:"118px"}}>
                                    <a target="_new" href="https://designer.wraps.hpwallart.com/j2blueprint?external_link=true&gsku=BNN" className="text-decoration-none">
                                        <span className="box-content px-1 py-4 text-center d-block">
                                            <span className="text-primary text-8 position-relative top-3 mt-3"><img src="/j2img/hpdesign/banner.png" alt="Banners"/></span>
                                            <span className="elements-list-shadow-icon text-default"><img src="/j2img/hpdesign/banner.png" alt="Banners"/></span>
                                            <span className="font-weight-bold text-uppercase text-1 negative-ls-1 d-block text-dark pt-2">Banners</span>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        
                        <div className="col-6 col-sm-4 col-lg-2">
                            <div className="featured-boxes featured-boxes-modern-style-2 featured-boxes-modern-style-2-hover-only featured-boxes-modern-style-primary m-0 mb-4 pb-3">
                                <div className="featured-box featured-box-no-borders featured-box-box-shadow" style={{height:"118px"}}>
                                    <a target="_new" href="https://designer.hpwallart.com/j2blueprint?external_link=true&sku=WA_CA" className="text-decoration-none">
                                        <span className="box-content px-1 py-4 text-center d-block">
                                            <span className="text-primary text-8 position-relative top-3 mt-3"><img src="/j2img/hpdesign/canvas.png" alt="Canvas"/></span>
                                            <span className="elements-list-shadow-icon text-default"><img src="/j2img/hpdesign/canvas.png" alt="Canvas"/></span>
                                            <span className="font-weight-bold text-uppercase text-1 negative-ls-1 d-block text-dark pt-2">Canvas</span>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-sm-4 col-lg-2">
                            <div className="featured-boxes featured-boxes-modern-style-2 featured-boxes-modern-style-2-hover-only featured-boxes-modern-style-primary m-0 mb-4 pb-3">
                                <div className="featured-box featured-box-no-borders featured-box-box-shadow" style={{height:"118px"}}>
                                    <a target="_new" href="https://designer.hpwallart.com/j2blueprint?external_link=true&gsku=RLUP" className="text-decoration-none">
                                        <span className="box-content px-1 py-4 text-center d-block">
                                            <span className="text-primary text-8 position-relative top-3 mt-3"><img src="/j2img/hpdesign/roller.png" alt="Roller Banners"/></span>
                                            <span className="elements-list-shadow-icon text-default"><img src="/j2img/hpdesign/roller.png" alt="Roller Banners"/></span>
                                            <span className="font-weight-bold text-uppercase text-1 negative-ls-1 d-block text-dark pt-2">Roller Banners</span>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-sm-4 col-lg-2">
                            <div className="featured-boxes featured-boxes-modern-style-2 featured-boxes-modern-style-2-hover-only featured-boxes-modern-style-primary m-0 mb-4 pb-3">
                                <div className="featured-box featured-box-no-borders featured-box-box-shadow" style={{height:"118px"}}>
                                    <a target="_new" href="https://designer.hpwallart.com/j2blueprint?external_link=true&gsku=CTL" className="text-decoration-none">
                                        <span className="box-content px-1 py-4 text-center d-block">
                                            <span className="text-primary text-8 position-relative top-3 mt-3"><img src="/j2img/hpdesign/citylights.png" alt="City Lights"/></span>
                                            <span className="elements-list-shadow-icon text-default"><img src="/j2img/hpdesign/banner.png" alt="City Lights"/></span>
                                            <span className="font-weight-bold text-uppercase text-1 negative-ls-1 d-block text-dark pt-2">City Lights</span>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-sm-4 col-lg-2">
                            <div className="featured-boxes featured-boxes-modern-style-2 featured-boxes-modern-style-2-hover-only featured-boxes-modern-style-primary m-0 mb-4 pb-3">
                                <div className="featured-box featured-box-no-borders featured-box-box-shadow" style={{height:"118px"}}>
                                    <a target="_new" href="https://designer.wraps.hpwallart.com/j2blueprint?external_link=true&sku=FGR" className="text-decoration-none">
                                        <span className="box-content px-1 py-4 text-center d-block">
                                            <span className="text-primary text-8 position-relative top-3 mt-3"><img src="/j2img/hpdesign/floorgraphics.png" alt="Floor Graphics"/></span>
                                            <span className="elements-list-shadow-icon text-default"><img src="/j2img/hpdesign/floorgraphics.png" alt="Floor Graphics"/></span>
                                            <span className="font-weight-bold text-uppercase text-1 negative-ls-1 d-block text-dark pt-2">Floor Graphics</span>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-sm-4 col-lg-2">
                            <div className="featured-boxes featured-boxes-modern-style-2 featured-boxes-modern-style-2-hover-only featured-boxes-modern-style-primary m-0 mb-4 pb-3">
                                <div className="featured-box featured-box-no-borders featured-box-box-shadow" style={{height:"118px"}}>
                                    <a target="_new"  href="https://designer.hpwallart.com/j2blueprint?external_link=true&sku=GFW" className="text-decoration-none">
                                        <span className="box-content px-1 py-4 text-center d-block">
                                            <span className="text-primary text-8 position-relative top-3 mt-3"><img src="/j2img/hpdesign/giftwraps.png" alt="Gift Wraps"/></span>
                                            <span className="elements-list-shadow-icon text-default"><img src="/j2img/hpdesign/giftwraps.png" alt="Gift Wraps"/></span>
                                            <span className="font-weight-bold text-uppercase text-1 negative-ls-1 d-block text-dark pt-2">Gift Wraps</span>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-sm-4 col-lg-2">
                            <div className="featured-boxes featured-boxes-modern-style-2 featured-boxes-modern-style-2-hover-only featured-boxes-modern-style-primary m-0 mb-4 pb-3">
                                <div className="featured-box featured-box-no-borders featured-box-box-shadow" style={{height:"118px"}}>
                                    <a target="_new" href="https://designer.hpwallart.com/j2blueprint?external_link=true&sku=PSTR" className="text-decoration-none">
                                        <span className="box-content px-1 py-4 text-center d-block">
                                            <span className="text-primary text-8 position-relative top-3 mt-3"><img src="/j2img/hpdesign/posters.png" alt="Posters"/></span>
                                            <span className="elements-list-shadow-icon text-default"><img src="/j2img/hpdesign/posters.png" alt="Posters"/></span>
                                            <span className="font-weight-bold text-uppercase text-1 negative-ls-1 d-block text-dark pt-2">Posters</span>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-sm-4 col-lg-2">
                            <div className="featured-boxes featured-boxes-modern-style-2 featured-boxes-modern-style-2-hover-only featured-boxes-modern-style-primary m-0 mb-4 pb-3">
                                <div className="featured-box featured-box-no-borders featured-box-box-shadow" style={{height:"118px"}}>
                                    <a target="_new" href="https://designer.hpwallart.com/j2blueprint?external_link=true&sku=WA_WC" className="text-decoration-none">
                                        <span className="box-content px-1 py-4 text-center d-block">
                                            <span className="text-primary text-8 position-relative top-3 mt-3"><img src="/j2img/hpdesign/wallcovering.png" alt="Wall Coverings"/></span>
                                            <span className="elements-list-shadow-icon text-default"><img src="/j2img/hpdesign/wallcovering.png" alt="Wall Coverings"/></span>
                                            <span className="font-weight-bold text-uppercase text-1 negative-ls-1 d-block text-dark pt-2">Wall Coverings</span>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-sm-4 col-lg-2">
                            <div className="featured-boxes featured-boxes-modern-style-2 featured-boxes-modern-style-2-hover-only featured-boxes-modern-style-primary m-0 mb-4 pb-3">
                                <div className="featured-box featured-box-no-borders featured-box-box-shadow" style={{height:"118px"}}>
                                    <a target="_new" href="https://designer.hpwallart.com/j2blueprint?external_link=true&sku=WA_WD" className="text-decoration-none">
                                        <span className="box-content px-1 py-4 text-center d-block">
                                            <span className="text-primary text-8 position-relative top-3 mt-3"><img src="/j2img/hpdesign/walldecals.png" alt="Wall Decals"/></span>
                                            <span className="elements-list-shadow-icon text-default"><img src="/j2img/hpdesign/walldecals.png" alt="Wall Decals"/></span>
                                            <span className="font-weight-bold text-uppercase text-1 negative-ls-1 d-block text-dark pt-2">Wall Decals</span>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                        <div className="col-6 col-sm-4 col-lg-2">
                            <div className="featured-boxes featured-boxes-modern-style-2 featured-boxes-modern-style-2-hover-only featured-boxes-modern-style-primary m-0 mb-4 pb-3">
                                <div className="featured-box featured-box-no-borders featured-box-box-shadow" style={{height:"118px"}}>
                                    <a target="_new" href="https://designer.hpwallart.com/j2blueprint?external_link=true&sku=WGR" className="text-decoration-none">
                                        <span className="box-content px-1 py-4 text-center d-block">
                                            <span className="text-primary text-8 position-relative top-3 mt-3"><img src="/j2img/hpdesign/windowgraphics.png" alt="Window Graphics"/></span>
                                            <span className="elements-list-shadow-icon text-default"><img src="/j2img/hpdesign/windowgraphics.png" alt="Window Graphics"/></span>
                                            <span className="font-weight-bold text-uppercase text-1 negative-ls-1 d-block text-dark pt-2">Window Graphics</span>
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
    
                    </div>

           
                
            
      
                    </div>
                    <div className="col-md-3"></div>
                </div>
                <section className="call-to-action call-to-action-dark mb-5">
					<div className="container">
						<div className="row">
							<div className="col-sm-12 col-lg-12 text-center">
								<div className="call-to-action-content text-center">
									<h3>If you have any <strong>questions</strong> about designing for print, reach out, we've got your <strong>answers!</strong></h3>
									
								</div>
							</div>
							
						</div>
					</div>
				</section>
                <ContactForm email="help" subject="Contact Form [ HP Poster Design Page ]"/>
                </div>
            <Footer />
            </div>
        );
    }

}






